const PublicChatThreadLoading = () => (
    <div
        className='chatThreadPublicLoading'
        role='status'
        aria-live='polite'
    >
        <span className='chatThreadPublicLoadingSpinner' aria-hidden='true' />
        <span className='chatThreadPublicLoadingLabel'>
            Loading conversation
        </span>
    </div>
);

export default PublicChatThreadLoading;
